import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import VariableType from 'app/admin/modelAnn/dto/VariableType';
import EditFormComponentMassSomethingField from 'app/admin/common/component/EditFormComponentMassSomethingField';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormFileInputField from 'modules/ui/editform/fields/EditFormFileInputField';
import EditFormImageInputField from 'modules/ui/editform/fields/EditFormImageInputField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormCheckboxField from 'modules/ui/editform/fields/EditFormCheckboxField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import EntriesListComponent from 'app/admin/model/component/EntriesListComponent';
import { useParams, withRouter } from 'react-router';
import StorageDriverService from 'app/admin/driver/service/StorageDriverService';
import ModelCalculate from 'app/admin/common/component/ModelCalculate';
import HysysModelEditService from '../service/HysysModelEditService';
import LoadHysysInputAttributesButton from '../component/LoadHysysInputAttributesButton';
import LoadHysysAttributeInfoButton from '../component/LoadHysysAttributeInfoButton';
import LoadHysysAttributeButtons from '../component/LoadHysysAttributeButtons';
import EditFormComponentListField from '../component/EditFormComponentListField';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const USE_NEW_HYSYS_ATTRIBUTE_BUTTONS = true;
const USE_HYSYS_ATTRIBUTE_TEST_RESPONSES = process.env.NODE_ENV !== 'production';

const config = data => {
	const storageDriverService = new StorageDriverService();
	return {
		key: 'hysysModelEditForm',
		topic: 'model',
		service: HysysModelEditService,
		// noNavigationAfterSave: data.id === 'new',
		// noNavigationAfterSaveNewLink: result => `/model-hysys/${result.id}`,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'inputAttributes' }, { key: 'outputAttributes' }/*, { key: 'entries' }*/];
		},
		backLink: () => '/model',
		defaultValue: () => HysysModelEditService.create(data.driverName),
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'driver',
					component: EditFormSelectField,
					required: true,
					items: () => storageDriverService.getListSelectionByDriverType('hysys')
				},
				{
					key: 'version',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				// {
				// 	key: 'entries',
				// 	component: EntriesListComponent,
				// 	isControlledInput: false,
				// 	required: true,
				// 	method: 'hysysModelEditControl/addModelEntry',
				// 	types: [
				// 		{ name: 'Hsc', fieldName: 'hscFile', accept: '.hsc' }
				// 	],
				// 	tab: 'entries'
				// },
				// {
				// 	key: 'hsc_file',
				// 	component: EditFormFileInputField,
				// 	required: true
				// },
				{
					key: 'image',
					component: EditFormImageInputField,
					required: true
				},
				{
					key: 'inputAttributes',
					tab: 'inputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					defaultValue: {
						id: null,
						name: null,
						type: null,
						spreadsheet: null,
						cell: null,
						value: null,
						minValue: null,
						maxValue: null,
						uom: null,
						expression: null,
						stream: null,
						useUom: false,
						orderIndex: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(VariableType).map(key => {
								return { label: VariableType[key], value: key };
							})
						},
						{
							key: 'spreadsheet',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'SpreadSheet'
						},
						{
							key: 'cell',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'SpreadSheet'
						},
						{
							key: 'expression',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'stream',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'ComponentMassFlow' || type === 'ComponentMassFrac'
						},
						{
							key: 'value',
							component: EditFormTextField,
							required: true,
							type: 'number',
							dependsOn: 'type',
							visibleIf: type => type === 'Variable' || type === 'SpreadSheet'
						},
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							dependsOn: 'type',
							visibleIf: type => type === 'ComponentMassFrac' || type === 'ComponentMassFlow'
						},
						{
							key: 'minValue',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable' || type === 'SpreadSheet' || type === null,
							type: 'number'
						},
						// {
						// 	key: 'min_value',
						// 	component: EditFormComponentMassSomethingField,
						// 	loadValueFrom: 'value',
						// 	loadValueMultiplier: 0.9,
						// 	dependsOn: 'type',
						// 	visibleIf: type => type === 'ComponentMassFrac',
						// 	enumByField: 'components'
						// },
						{
							key: 'maxValue',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable' || type === 'SpreadSheet' || type === null,
							type: 'number'
						},
						// {
						// 	key: 'max_value',
						// 	component: EditFormComponentMassSomethingField,
						// 	loadValueFrom: 'value',
						// 	loadValueMultiplier: 1.1,
						// 	dependsOn: 'type',
						// 	visibleIf: type => type === 'ComponentMassFrac',
						// 	enumByField: 'components'
						// },
						{
							key: 'uom',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'SpreadSheet' || type === 'Variable'
						},
						{
							key: 'useUom',
							component: EditFormCheckboxField,
							dependsOn: 'type',
							visibleIf: type => type === 'SpreadSheet'
						}
					]
				},
				{
					key: 'outputAttributes',
					tab: 'outputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					defaultValue: {
						id: null,
						name: null,
						type: null,
						spreadsheet: null,
						cell: null,
						uom: null,
						expression: null,
						stream: null,
						useUom: false,
						orderIndex: null,
						components: []
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(VariableType).map(key => {
								return { label: VariableType[key], value: key };
							})
						},
						{
							key: 'spreadsheet',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'SpreadSheet'
						},
						{
							key: 'cell',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'SpreadSheet'
						},

						{
							key: 'expression',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'stream',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'ComponentMassFlow' || type === 'ComponentMassFrac'
						},
						// {
						// 	key: 'components',
						// 	component: EditFormComponentListField,
						// 	required: true,
						// 	multiple: true,
						// 	query: () => new Promise(resolve => resolve([])),
						// 	dependsOn: 'type',
						// 	visibleIf: type => type === 'ComponentMassFlow' || type === 'ComponentMassFrac'
						// },
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							dependsOn: 'type',
							visibleIf: type => type === 'ComponentMassFlow' || type === 'ComponentMassFrac'
						},
						{
							key: 'uom',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'SpreadSheet' || type === 'Variable'
						},
						{
							key: 'useUom',
							component: EditFormCheckboxField,
							dependsOn: 'type',
							visibleIf: type => type === 'SpreadSheet'
						}
					]
				}
			];
			return fields;
		}
	};
};

function HysysModelEditForm() {
	const { id, tabKey, driverName } = useParams();
	const dispatch = useDispatch();
	const myConfig = config({ id, driverName });
	return (
		<EditFormPage
			config={myConfig}
			startTabValue={tabKey}
			beforeSaveContent={
				<>
					{USE_NEW_HYSYS_ATTRIBUTE_BUTTONS ? (
						<LoadHysysAttributeButtons id={id} useTestResponses={USE_HYSYS_ATTRIBUTE_TEST_RESPONSES} />
					) : (
						<>
							<LoadHysysInputAttributesButton id={id} />
							<LoadHysysAttributeInfoButton id={id} />
						</>
					)}
					<ModelCalculate id={id} type='model' />
				</>
			}
		// onSave={result => {
		// 	if (!result.engineSuccessful) dispatch(showMessage({ message: `Engine: ${result.engineMessage}` }));
		// }}
		/>
	);
}

export default withRouter(HysysModelEditForm);
